import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-10 ui-cell" }, " Valor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell" }, " Cor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Ativa "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_9 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-10 ui-cell",
  "data-title": "Valor"
}
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell",
  "data-title": "Cor"
}
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell",
  "data-title": "Ativa"
}
const _hoisted_14 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_15 = { class: "ui-actions" }
const _hoisted_16 = { class: "ui-action ui-move" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, { label: "Nova cor" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  ref: "campoNovoValor",
                  type: "text",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoValor) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.adicionarItem()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.novoValor]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, { label: "Selecione uma cor" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.novaCor) = $event)),
                  class: "ant-input ui-select-cor"
                }, null, 512), [
                  [_vModelText, _ctx.state.novaCor]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ui-button -primary ui-mh-32 ui-full",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarItem()))
                }, _hoisted_6)
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.computedItensCores.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma cor foi adicionada ainda"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.computedItensCores,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedItensCores) = $event)),
                  "item-key": "index",
                  handle: ".ui-move"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-row ui-row"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_a_input, {
                          class: "ant-input",
                          value: element.valor,
                          "onUpdate:value": ($event: any) => ((element.valor) = $event)
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "color",
                          "onUpdate:modelValue": ($event: any) => ((element.apresentacao) = $event),
                          class: "ant-input ui-select-cor"
                        }, null, 8, _hoisted_12), [
                          [_vModelText, element.apresentacao]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_selecionar_sim_nao, {
                          valor: element.status,
                          "onUpdate:valor": ($event: any) => ((element.status) = $event)
                        }, null, 8, ["valor", "onUpdate:valor"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar os itens" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_16, [
                                _createVNode(_component_icone, { nome: "ordenar-lista" })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.removerItem(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_17)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}